import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

import AppDatePicker from '@/corePagesModule/components/AppDatePicker.vue';
import { i18n } from '@/i18n';
import { computed } from 'vue';
import { DateService } from '@/coreDomainsModule/services/dateService';
import Mdi from './Mdi.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DateInput',
  props: {
    modelValue: {},
    placeholder: { default: undefined },
    disabled: { type: Boolean },
    format: { default: 'yyyy/MM/dd' },
    minDate: { default: undefined },
    textCentering: { type: Boolean },
    displayIcon: { type: Boolean },
    autoApply: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

const props = __props;
const emits = __emit;

const locale = computed(() => i18n.locale);
const computedModelValue = computed({
  /** 取得する */
  get: () => props.modelValue,
  /**
   * 設定する
   * @param v - value
   */
  set: (v) => {
    if (!v) return;
    emits('update:modelValue', v);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppDatePicker, {
    modelValue: computedModelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((computedModelValue).value = $event)),
    "model-type": "timestamp",
    "mode-height": 1,
    format: _ctx.format,
    "enable-time-picker": false,
    "month-change-on-scroll": false,
    teleport: true,
    locale: locale.value,
    placeholder: _unref(t)('日付を選択'),
    "select-text": _unref(t)('選択'),
    "cancel-text": _unref(t)('キャンセル'),
    "show-now-button": true,
    clearable: false,
    "now-button-label": _unref(t)('現在を選択'),
    "auto-position": false,
    pad: "",
    disabled: _ctx.disabled,
    "min-date": props.minDate,
    "auto-apply": props.autoApply
  }, {
    trigger: _withCtx(() => [
      _createElementVNode("button", {
        class: _normalizeClass(["date-input", { 'date-input--disabled': _ctx.disabled, 'date-input--center': _ctx.textCentering }])
      }, [
        (_ctx.displayIcon)
          ? (_openBlock(), _createBlock(Mdi, {
              key: 0,
              icon: ""
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass({ 'date-input--placeholder': !computedModelValue.value })
        }, _toDisplayString(computedModelValue.value ? _unref(DateService).convertMSUnixTimeToYYYYMMDDSlash(computedModelValue.value) : _ctx.placeholder ?? ''), 3)
      ], 2)
    ]),
    _: 1
  }, 8, ["modelValue", "format", "locale", "placeholder", "select-text", "cancel-text", "now-button-label", "disabled", "min-date", "auto-apply"]))
}
}

})